module.exports = __webpack_public_path__ + "static/media/photo205.c0c243b8.jpg";